import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import forms from 'modules/enps/store/collections/forms'
import type EnpsForm from 'modules/enps/store/models/Form'

export function useForm(
  refreshForm: boolean,
  setRefreshForm: (param: boolean) => void
): {
  loading: boolean
  form: EnpsForm | undefined
} {
  const [form, setForm] = React.useState<EnpsForm>()

  const { loading } = useAsyncData(async () => {
    if (!!form || !refreshForm) return

    await forms.fetch()
    setForm(forms.models[0] as EnpsForm)
    setRefreshForm(false)
  }, [refreshForm])

  return {
    loading,
    form,
  }
}
